module.exports = __webpack_public_path__ + "static/media/cobros.24f89f5f.svg";